import ExpansionChip from './ExpansionChip';

export default ExpansionChip;
